import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "../components/CustomButtons/Button.js";
import Slide from "@material-ui/core/Slide";

import confirmationModalStyle from "assets/jss/material-dashboard-react/views/pageStyle";
import brandTheme from "brandTheme/Theme.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

class ConfirmationModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardAnimaton: "cardHidden",
      confirmationModal: false,
      confirmationModalHeader: "",
      confirmationModalMsg: "",
    };
  }
  handlePositiveButton() {
    if (this.props.handlePositiveButton) {
      this.props.handlePositiveButton();
    }
  }
  handleNegativeButton() {
    this.props.handleNegativeButton();
  }
  componentDidMount() {
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (props.confirmationModal !== state.confirmationModal) {
      let statusDetails = {};
      if (props.confirmationModal) {
        statusDetails = {
          confirmationModal: props.confirmationModal,
          confirmationModalHeader: props.confirmationModalHeader,
          confirmationModalMsg: props.confirmationModalMsg,
        };
      }
      return {
        confirmationModal: props.confirmationModal,
        ...statusDetails,
      };
    }
    return null;
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }

  render() {
    const { classes, rejectApplication = false } = this.props;

    return (
      <div className={classes.container}>
        <Dialog
          classes={{
            root: classes.center + " " + classes.modalRoot,
            paper: classes.modal,
          }}
          open={this.state.confirmationModal}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => this.handleNegativeButton()}
          aria-labelledby="notice-modal-slide-title"
          aria-describedby="notice-modal-slide-description"
        >
          {/* <DialogTitle
            id="notice-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <h4 className={classes.modalTitle}>
              {this.state.confirmationModalHeader}
            </h4>
          </DialogTitle> */}
<DialogContent
  className={classes.modalBody}
  style={{
    textAlign: "center",
    padding: "24px 40px 32px",
  }}
>
  <div
    style={{
      width: 200,
      margin: "0 auto",
    }}
  >
    <img
      src={rejectApplication ? "/images/rejectApplication.png" : "/images/approval.png"}
      alt={rejectApplication ? "Rejected" : "Approved"}
      style={{
        width: "100%",
        display: "block",
      }}
    />
  </div>

  <h2
    style={{
      color: "#15254F",
      fontWeight: 700,
      fontSize: rejectApplication ? 35 : 28,
      margin: "0 0 12px",
    }}
  >
    {rejectApplication ? "Reject Loan" : "Loan Approved!"}
  </h2>

 {!rejectApplication &&  <p
    style={{
      color: "#6B7280",
      fontSize: 15,
      margin: "0 0 24px",
      lineHeight: "22px",
    }}
  >
    Congratulations! You are eligible for loan amount of
  </p>}

  <div

    style={{
      fontSize: rejectApplication ? 28 : 42,
      fontWeight: 800,
      color: "#15254F",
      marginBottom: 4,
      lineHeight: rejectApplication ? "40px" : "50px",
    }}
  >
    {this.state.confirmationModalMsg}
  </div>
</DialogContent>
          <DialogActions
            className={classes.modalFooter + " " + classes.modalFooterCenter}
          >
         <Button
  round
  size="lg"
  onClick={() => this.handlePositiveButton()}
  style={{
    minWidth: 220,
    height: 52,
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
    color: "#fff",
    fontWeight: 700,
    fontSize: 15,
    borderRadius: 28,
    boxShadow: "0 8px 20px rgba(21,37,79,.25)",
  }}
>
  CONFIRM
</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

ConfirmationModal.propTypes = {
  classes: PropTypes.object,
  confirmationModal: PropTypes.bool.isRequired,
  confirmationModalHeader: PropTypes.string,
  confirmationModalMsg: PropTypes.string.isRequired,
  handleNegativeButton: PropTypes.func.isRequired,
  handlePositiveButton: PropTypes.func.isRequired,
};

export default withStyles(confirmationModalStyle)(ConfirmationModal);
